import useResponsive from 'hooks/useResponsive';
import useTranslation from 'hooks/useTranslation';
import React from 'react';
import style from './index.style';
import Icon from '../utils/Icon';
import { useSelector } from 'react-redux';
import Button from '../utils/Button';
import { useRouterWithLang } from 'hooks/useRouterWithLang';

export default function Dropshipping() {
  const { TRANSLATIONS, translationsParameters } = useTranslation();
  const { isMobile } = useResponsive();
  const router = useRouterWithLang();
  const isLoggedIn = useSelector((s) => s.isLoggedIn);

  return (
    <div className="reseller">
      <div className="reseller-header white relative">
        <div className="reseller-header-wrapper d-f ai-c row">
          <div className="ta-c d-f jc-c ai-c g-30 fd-c">
            <h1 className={'black'}>
              {translationsParameters(TRANSLATIONS.pages.dropshipping.title, [
                <span className="text-gradient">
                  {TRANSLATIONS.pages.dropshipping.titleBold}
                </span>,
              ])}
            </h1>
            <h2 className={'black'} style={{ lineHeight: '24px' }}>
              {translationsParameters(TRANSLATIONS.pages.dropshipping.title_2, [
                <span style={{ fontWeight: 'bold', color: '#005eff' }}>
                  {TRANSLATIONS.pages.dropshipping.bdroppy}
                </span>,
              ])}
            </h2>
            <p
              className={'black'}
              style={{ lineHeight: '24px', maxWidth: 700 }}
            >
              {TRANSLATIONS.pages.dropshipping.subTitle}
            </p>
            <div className={'d-f g-10'}>
              <Button
                className={'large primary'}
                label={TRANSLATIONS.pages.dropshipping.cta_1}
                onClick={() => {
                  router.push('/register');
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={'jc-c d-f  blue-gradient'}>
        <img
          src={TRANSLATIONS.pages.dropshipping.img}
          alt={'dropshipping image'}
        />
      </div>
      <div className="reseller-block white">
        <div className="reseller-block-wrapper  d-f fd-c g-30 ta-c">
          <h2 className={'black'}>
            {TRANSLATIONS.pages.dropshipping.multiChannel}
          </h2>
          <h5 className={'black'}>
            {TRANSLATIONS.pages.dropshipping.integratedWith}
          </h5>
          <div className="row d-f jc-sb">
            <div className={`col-integrations ${isMobile && 'col-6'}`}>
              <div className="integrations d-f fd-c ai-c jc-c">
                <img
                  src={TRANSLATIONS.pages.reseller.logo_1}
                  alt="logo-woocommerce"
                />
              </div>
            </div>
            <div className={`col-integrations ${isMobile && 'col-6'}`}>
              <div className="integrations d-f fd-c ai-c jc-c">
                <img
                  src={TRANSLATIONS.pages.reseller.logo_2}
                  alt="logo-prestashop"
                />
              </div>
            </div>
            <div className={`col-integrations ${isMobile && 'col-6 '}`}>
              <div className="integrations d-f fd-c ai-c jc-c">
                <img
                  src={TRANSLATIONS.pages.reseller.logo_3}
                  alt="logo-squarespace"
                />
              </div>
            </div>
            <div className={`col-integrations ${isMobile && 'col-6 '}`}>
              <div className="integrations d-f fd-c ai-c jc-c">
                <img
                  src={TRANSLATIONS.pages.reseller.logo_4}
                  alt="logo-shopify"
                />
              </div>
            </div>
            <div className={`col-integrations ${isMobile && 'col-6'}`}>
              <div className="integrations d-f fd-c ai-c jc-c">
                <img src={TRANSLATIONS.pages.reseller.logo_6} alt="logo-wix" />
              </div>
            </div>
            <div className={`col-integrations ${isMobile && 'col-6'}`}>
              <div className="integrations d-f fd-c ai-c jc-c">
                <img
                  src={TRANSLATIONS.pages.reseller.logo_7}
                  alt="logo-amazon"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="reseller-block white">
        <div className="reseller-block-wrapper d-f g-10 jc-c ai-c row">
          <div className="col-md-5 box-blue blue-gradient d-f g-30 fd-c">
            <ul>
              <li>
                <Icon
                  type={'check-circle'}
                  style={{ color: 'var(--accent)' }}
                />
                {TRANSLATIONS.pages.reseller.li_1}
              </li>
              <li>
                <Icon
                  type={'check-circle'}
                  style={{ color: 'var(--accent)' }}
                />
                {TRANSLATIONS.pages.reseller.li_2}
              </li>
              <li>
                <Icon
                  type={'check-circle'}
                  style={{ color: 'var(--accent)' }}
                />
                {TRANSLATIONS.pages.reseller.li_3}
              </li>
              <li>
                <Icon
                  type={'check-circle'}
                  style={{ color: 'var(--accent)' }}
                />
                {TRANSLATIONS.pages.reseller.li_4}
              </li>
            </ul>
          </div>
          <div className="col-md-5 box-blue blue-gradient d-f g-30 fd-c">
            <ul>
              <li>
                <Icon
                  type={'check-circle'}
                  style={{ color: 'var(--accent)' }}
                />
                {TRANSLATIONS.pages.reseller.li_5}
              </li>
              <li>
                <Icon
                  type={'check-circle'}
                  style={{ color: 'var(--accent)' }}
                />
                {TRANSLATIONS.pages.reseller.li_6}
              </li>
              <li>
                <Icon
                  type={'check-circle'}
                  style={{ color: 'var(--accent)' }}
                />
                {TRANSLATIONS.pages.reseller.li_7}
              </li>
              <li>
                <Icon
                  type={'check-circle'}
                  style={{ color: 'var(--accent)' }}
                />
                {TRANSLATIONS.pages.reseller.li_8}
              </li>
            </ul>
          </div>
          <div className={'d-f fd-c jc-c ai-c box-blue-img'}>
            {!isMobile && (
              <img
                src={TRANSLATIONS.pages.dropshipping.img_1}
                alt="bdroppy"
                width={500}
              />
            )}
          </div>
        </div>
      </div>
      <div className="reseller-block blue-gradient">
        <div className="reseller-block-wrapper  d-f fd-c g-30 ta-c">
          <h2 className={'black'}>
            {TRANSLATIONS.pages.dropshipping.multiChannel}
          </h2>
          <h5 className={'black'}>
            {TRANSLATIONS.pages.dropshipping.integratedWith}
          </h5>
          <div className="row d-f jc-sb">
            <div className={`col-integrations ${isMobile && 'col-6'}`}>
              <div className="integrations_2 d-f fd-c ai-c jc-c">
                <img
                  src={
                    'https://www.mediabd.it/assets/public/2023-2/07/icon_.png'
                  }
                  alt="logo-woocommerce"
                />
                <p className={'black'}>
                  {TRANSLATIONS.pages.dropshipping.howItWorks_1}
                </p>
              </div>
            </div>
            <div className={`col-integrations ${isMobile && 'col-6'}`}>
              <div className="integrations_2 d-f fd-c ai-c jc-c">
                <img
                  src={
                    'https://www.mediabd.it/assets/public/2023-2/07/icon_2.png'
                  }
                  alt="logo-prestashop"
                />
                <p className={'black'}>
                  {TRANSLATIONS.pages.dropshipping.howItWorks_2}
                </p>
              </div>
            </div>
            <div className={`col-integrations ${isMobile && 'col-6 '}`}>
              <div className="integrations_2 d-f fd-c ai-c jc-c">
                <img
                  src={
                    'https://www.mediabd.it/assets/public/2023-2/07/icon_3.png'
                  }
                  alt="logo-squarespace"
                />
                <p className={'black'}>
                  {TRANSLATIONS.pages.dropshipping.howItWorks_3}
                </p>
              </div>
            </div>
            <div className={`col-integrations ${isMobile && 'col-6 '}`}>
              <div className="integrations_2 d-f fd-c ai-c jc-c">
                <img
                  src={
                    'https://www.mediabd.it/assets/public/2023-2/07/icon_4.png'
                  }
                  alt="logo-shopify"
                />
                <p className={'black'}>
                  {TRANSLATIONS.pages.dropshipping.howItWorks_4}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{style}</style>
    </div>
  );
}
